module.exports = __webpack_public_path__ + "static/fonts/fa-regular-400.5623624.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fontawesome-5.10.2/webfonts/fa-regular-400.woff
// module id = 338
// module chunks = 1